import React from 'react';

// Matches the source design's arrow-right icon used on filled/ghost CTA buttons.
const PbdqArrowRightIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M5 12h14" />
        <path d="m12 5 7 7-7 7" />
    </svg>
);

export default PbdqArrowRightIcon;
